import React from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import LegalLayout from "../components/legal/LegalLayout";

const Support = () => (
  <LegalLayout title="Support" testId="support-content">
    <h1>Thryvin' Support</h1>

    <p className="intro">We're a small team and every message reaches a real person.</p>

    <section>
      <h2>Contact us</h2>
      <p>
        <a href="mailto:support@thryvin.app" className="email-link">
          <Mail size={16} />
          <strong>Email: support@thryvin.app</strong>
        </a>
      </p>
      <p>In the app: You → Settings → Help &amp; support.</p>
      <p>We usually reply within 2 working days.</p>
    </section>

    <section>
      <h2>Common questions</h2>

      <h3>How do I manage or cancel Thryvin' Pro?</h3>
      <p>
        Subscriptions are handled by the store you bought from. On iPhone: Settings → your name → Subscriptions. On
        Android: Google Play → Profile → Payments &amp; subscriptions → Subscriptions. Deleting your account doesn't
        cancel a subscription.
      </p>

      <h3>I've paid but Pro isn't showing.</h3>
      <p>
        Open the Thryvin' Pro screen in the app and tap Restore purchases, using the same Apple or Google account you
        paid with. If it still doesn't show, email us with the email address on your Thryvin' account.
      </p>

      <h3>How do I change my plan?</h3>
      <p>
        Ask your coach, or use the monthly check-in. Pro members can also rebuild their plan in You → Settings
        (Regenerate plan).
      </p>

      <h3>How do I get a copy of my data?</h3>
      <p>You → Settings → Privacy &amp; AI → Download my data.</p>

      <h3>How do I delete my account?</h3>
      <p>
        You → Settings → Delete account, or see{" "}
        <Link to="/delete-account" className="inline-link">
          Delete your account
        </Link>
        .
      </p>

      <h3>How do I report something in Community?</h3>
      <p>
        Tap ⋯ on any post, comment or profile, then Report. See our{" "}
        <Link to="/community-guidelines" className="inline-link">
          Community Guidelines
        </Link>
        .
      </p>
    </section>

    <section>
      <h2>Legal</h2>
      <p>
        <Link to="/privacy" className="inline-link">
          Privacy Policy
        </Link>{" "}
        ·{" "}
        <Link to="/terms" className="inline-link">
          Terms and Conditions
        </Link>{" "}
        ·{" "}
        <Link to="/community-guidelines" className="inline-link">
          Community Guidelines
        </Link>{" "}
        ·{" "}
        <Link to="/child-safety" className="inline-link">
          Child Safety Standards
        </Link>
      </p>
    </section>

    <p className="policy-footer-note">Thryvin' is run by Jake West in the United Kingdom.</p>
  </LegalLayout>
);

export default Support;
